"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const TreeNothingFound = react_1.default.memo(() => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: `TreeTreeNothingFound display-flex justify-content-center text-size-20
                padding-top-25 margin-top-25 margin-bottom-25` }, { children: (0, jsx_runtime_1.jsx)("span", { className: 'rioglyph rioglyph-looking-glass-man text-size-400pct text-color-light' }) })));
});
TreeNothingFound.displayName = 'TreeNothingFound';
TreeNothingFound.defaultProps = {};
TreeNothingFound.propTypes = {
    value: prop_types_1.default.string,
    className: prop_types_1.default.string,
};
exports.default = TreeNothingFound;
